"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SORT_OPTIONS = exports.POPULAR_TLDS = exports.DomainFilters = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _button = _interopRequireDefault(require("@ux/button"));
var _x = _interopRequireDefault(require("@ux/icon/x"));
var _checkmark = _interopRequireDefault(require("@ux/icon/checkmark"));
var _filter = _interopRequireDefault(require("@ux/icon/filter"));
var _reactMintl = require("@godaddy/react-mintl");
var _DomainFilters = require("../../../styles/DomainFilters");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const SORT_OPTIONS = exports.SORT_OPTIONS = {
  RECOMMENDED: 'recommended',
  PRICE_LOW_TO_HIGH: 'price_low_to_high'
};
const POPULAR_TLDS = exports.POPULAR_TLDS = ['.com', '.net', '.org', '.info'];

// Custom RadioIndicator component
const RadioIndicator = ({
  selected
}) => {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_DomainFilters.domainFiltersStyles.radioIndicator, {
      [_DomainFilters.domainFiltersStyles.radioIndicatorSelected]: selected
    })
  }, selected && /*#__PURE__*/_react.default.createElement(_checkmark.default, null));
};
const DomainFilters = ({
  onSortChange,
  onTldChange,
  onClose,
  initialSort = SORT_OPTIONS.RECOMMENDED,
  initialTlds = [],
  popularTlds = POPULAR_TLDS,
  availableTlds,
  className = ''
}) => {
  const {
    formatMessage
  } = (0, _reactMintl.useIntl)();
  const [selectedSort, setSelectedSort] = (0, _react.useState)(initialSort);
  const [selectedTlds, setSelectedTlds] = (0, _react.useState)(new Set(initialTlds));

  // Organize TLDs: popular first, then others alphabetically
  const organizedTlds = (0, _react.useMemo)(() => {
    return [...popularTlds.filter(tld => availableTlds.includes(tld)), ...availableTlds.filter(tld => !popularTlds.includes(tld)).sort()].filter((tld, index, arr) => arr.indexOf(tld) === index);
  }, [availableTlds, popularTlds]);
  const handleSortChange = sortOption => {
    setSelectedSort(sortOption);
    onSortChange?.(sortOption);
  };
  const handleTldToggle = tld => {
    const newTlds = new Set(selectedTlds);
    if (newTlds.has(tld)) {
      newTlds.delete(tld);
    } else {
      newTlds.add(tld);
    }
    setSelectedTlds(newTlds);
    onTldChange?.(Array.from(newTlds));
  };
  const handleClearAll = () => {
    setSelectedTlds(new Set());
    onTldChange?.([]);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_DomainFilters.domainFiltersStyles.container, className),
    "data-cy": "domain-filters"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _DomainFilters.domainFiltersStyles.mobileHeader,
    "data-cy": "mobile-header"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _DomainFilters.domainFiltersStyles.mobileTitle
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: _DomainFilters.domainFiltersStyles.filterIconWrapper
  }, /*#__PURE__*/_react.default.createElement(_filter.default, null)), /*#__PURE__*/_react.default.createElement("span", {
    className: _DomainFilters.domainFiltersStyles.titleText
  }, formatMessage({
    id: 'serp.filters.title',
    defaultMessage: 'FILTER'
  }))), /*#__PURE__*/_react.default.createElement("button", {
    className: _DomainFilters.domainFiltersStyles.closeButton,
    onClick: onClose,
    "aria-label": formatMessage({
      id: 'serp.filters.close_filters',
      defaultMessage: 'Close filters'
    }),
    "data-cy": "close-button"
  }, /*#__PURE__*/_react.default.createElement(_x.default, null))), /*#__PURE__*/_react.default.createElement("div", {
    className: _DomainFilters.domainFiltersStyles.section,
    "data-cy": "sort-section"
  }, /*#__PURE__*/_react.default.createElement("h3", {
    className: _DomainFilters.domainFiltersStyles.sectionTitle
  }, formatMessage({
    id: 'serp.filters.sort_by',
    defaultMessage: 'Sort by'
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: _DomainFilters.domainFiltersStyles.sortOptions
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: (0, _classnames.default)(_DomainFilters.domainFiltersStyles.sortOption, {
      [_DomainFilters.domainFiltersStyles.sortOptionSelected]: selectedSort === SORT_OPTIONS.RECOMMENDED
    }),
    onClick: () => handleSortChange(SORT_OPTIONS.RECOMMENDED),
    "data-cy": "sort-recommended"
  }, /*#__PURE__*/_react.default.createElement("span", null, formatMessage({
    id: 'serp.filters.recommended',
    defaultMessage: 'Recommended'
  })), /*#__PURE__*/_react.default.createElement(RadioIndicator, {
    selected: selectedSort === SORT_OPTIONS.RECOMMENDED
  })), /*#__PURE__*/_react.default.createElement("button", {
    className: (0, _classnames.default)(_DomainFilters.domainFiltersStyles.sortOption, {
      [_DomainFilters.domainFiltersStyles.sortOptionSelected]: selectedSort === SORT_OPTIONS.PRICE_LOW_TO_HIGH
    }),
    onClick: () => handleSortChange(SORT_OPTIONS.PRICE_LOW_TO_HIGH),
    "data-cy": "sort-price"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _DomainFilters.domainFiltersStyles.sortOptionText
  }, /*#__PURE__*/_react.default.createElement("span", null, formatMessage({
    id: 'serp.filters.price',
    defaultMessage: 'Price'
  })), /*#__PURE__*/_react.default.createElement("span", {
    className: _DomainFilters.domainFiltersStyles.sortOptionSubtitle
  }, formatMessage({
    id: 'serp.filters.low_to_high',
    defaultMessage: 'Low → High'
  }))), /*#__PURE__*/_react.default.createElement(RadioIndicator, {
    selected: selectedSort === SORT_OPTIONS.PRICE_LOW_TO_HIGH
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_DomainFilters.domainFiltersStyles.section, _DomainFilters.domainFiltersStyles.sectionContent),
    "data-cy": "tlds-section"
  }, /*#__PURE__*/_react.default.createElement("h3", {
    className: _DomainFilters.domainFiltersStyles.sectionTitle
  }, formatMessage({
    id: 'serp.filters.filter_by_tlds',
    defaultMessage: 'Filter by domain TLDs'
  })), /*#__PURE__*/_react.default.createElement(_button.default, {
    design: "secondary",
    text: formatMessage({
      id: 'serp.filters.clear_all',
      defaultMessage: 'Clear All'
    }),
    className: _DomainFilters.domainFiltersStyles.clearAllButton,
    icon: /*#__PURE__*/_react.default.createElement("div", {
      className: _DomainFilters.domainFiltersStyles.clearIconWrapper
    }, /*#__PURE__*/_react.default.createElement(_x.default, null)),
    size: "small",
    onClick: handleClearAll,
    "data-cy": "clear-all-button"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _DomainFilters.domainFiltersStyles.tldContainer
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _DomainFilters.domainFiltersStyles.tldGrid,
    "data-cy": "tld-grid"
  }, organizedTlds.map(tld => /*#__PURE__*/_react.default.createElement("button", {
    key: tld,
    className: (0, _classnames.default)(_DomainFilters.domainFiltersStyles.tldButton, {
      [_DomainFilters.domainFiltersStyles.tldButtonSelected]: selectedTlds.has(tld)
    }),
    onClick: () => handleTldToggle(tld),
    "data-cy": `tld-button${tld}`
  }, tld))))));
};
exports.DomainFilters = DomainFilters;